import { Injectable } from '@angular/core';
import { LocalStorageKey } from '@app/shared/models/local-storage';

@Injectable({
  providedIn: 'root'
})
export class S1LocalStorageService {

  constructor() { }

  saveSearch(key: LocalStorageKey, data: any) {
    localStorage.setItem(LocalStorageKey[key], JSON.stringify(data));
  }

  loadSearch(key: LocalStorageKey): any {
    return JSON.parse(localStorage.getItem(LocalStorageKey[key]));
  }

}
